var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResizeSmallIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9182_116135)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.5998 13.6L9.5998 15.2L13.5998 15.2C14.4798 15.2 15.1998 14.48 15.1998 13.6L15.1998 2.4C15.1998 1.52 14.4798 0.8 13.5998 0.8L2.3998 0.8C1.5198 0.8 0.799804 1.52 0.799804 2.4L0.799804 6.4L2.3998 6.4L2.3998 2.4L13.5998 2.4L13.5998 13.6L9.5998 13.6Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.71963 6.88L5.35963 9.52L0.799629 14.08L1.91963 15.2L6.47963 10.64L9.11963 13.28L9.11963 6.88L2.71963 6.88Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9182_116135"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 16) rotate(-90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResizeSmallIcon);
export default __webpack_public_path__ + "static/media/resize-small-icon.8401d0859b497a084485c02aca30bc03.svg";
export { ForwardRef as ReactComponent };